import { Component } from '@angular/core';

@Component({
  selector: 'app-network-delay-popover',
  templateUrl: 'network-delay-popover.component.html',
  styleUrls: ['network-delay-popover.component.scss'],
})
export class NetworkDelayPopoverComponent {
  public dataDelays = [
    {
      network: 'NAMP',
      time: '24 HOURS',
    },
    {
      network: 'ROPD',
      time: 'REAL TIME',
    },
    {
      network: 'ROPDION',
      time: 'REAL TIME',
    },
    {
      network: 'ROPDT',
      time: 'REAL TIME',
    },
    {
      network: 'ROPDB',
      time: 'REAL TIME',
    },
    {
      network: 'ROPDBION',
      time: 'REAL TIME',
    },
    {
      network: 'ROTAM',
      time: 'REAL TIME',
    },
    {
      network: 'ROTEU',
      time: 'REAL TIME',
    },
    {
      network: 'ROTAS',
      time: 'REAL TIME',
    },
    {
      network: 'ROKN',
      time: 'REAL TIME',
    },
    {
      network: 'ROTAU',
      time: 'REAL TIME',
    },
    {
      network: 'ROTGL',
      time: 'REAL TIME',
    },
    {
      network: 'ROTBR',
      time: 'REAL TIME',
    },
    {
      network: 'ROTBS',
      time: 'REAL TIME',
    },
    {
      network: 'NAUS',
      time: 'REAL TIME',
    },
    {
      network: 'UKA',
      time: '35 MIN',
    },
    {
      network: 'ROAF',
      time: '35 MIN',
    },
    {
      network: 'NATM',
      time: '15 MIN',
    },
    {
      network: 'ROTN',
      time: '24 HOURS',
    },
    {
      network: 'ROCT',
      time: '10 MIN',
    },
    {
      network: 'NAVZ',
      time: '24 HOURS',
    },
    {
      network: 'PEPVZ',
      time: '24 HOURS',
    },
    {
      network: 'UKMI',
      time: '24 HOURS',
    },
    {
      network: 'UKP',
      time: '25 MIN',
    },
    {
      network: 'UKRO',
      time: '24 HOURS',
    },
    {
      network: 'UKTM',
      time: '24 HOURS',
    },
    {
      network: 'UKAT',
      time: '24 HOURS',
    },
    {
      network: 'UKKR',
      time: '25 MIN',
    },
    {
      network: 'UKMX',
      time: 'REAL TIME',
    },
    {
      network: 'UKJ',
      time: 'REAL TIME',
    },
    {
      network: 'UKX',
      time: '35 MIN',
    },
    {
      network: 'P1SCVF',
      time: 'REAL TIME',
    },
    {
      network: 'PAN3EC',
      time: '15 MIN',
    },
    {
      network: 'PSC2TN',
      time: '15 MIN',
    },
  ];
}
